module.exports = __webpack_public_path__ + "media/images/home/concept_scene_2_sp-1bfcd646b034888a35e5bf604fb4cb57.png";